import { getCookie } from "../../utils/cookie";
import { getPageIdInfo } from "../../utils/common";
var setClostMarkByPageId = function setClostMarkByPageId() {
  var pageInfo = getPageIdInfo();
  var pageId = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.pageId;
  if (!pageId) return;
  var __t = getCookie('t') || '';
  __t = __t ? Number(__t) : 25;
  var inApp = [15, 16, 78, 79].indexOf(__t) > -1;
  if (inApp) {
    try {
      window.__ZZAPP__['setCloseMark']({
        mark: pageId
      });
    } catch (error) {}
  }
};
export default setClostMarkByPageId;